import { LeaderCardProps } from './types';

export const LEADERS: LeaderCardProps[] = [
  {
    avatar:
      'https://crehana-vercel-images-prd.imgix.net/public/1ba0c697-8167-43bb-89f4-ceec867c6095-image-(1).png?auto=format&fit=clip',
    name: 'Kiara Artieda',
    role: 'LEADERS_ROLE1',
    companyLogo:
      'https://crehana-vercel-images-prd.imgix.net/public/de20c8a0-d569-4779-9e8c-a66cfacfece1-image.png?auto=format&fit=clip',
    description: 'LEADERS_STORY1',
  },
  {
    avatar:
      'https://crehana-vercel-images-prd.imgix.net/public/3f22bab6-1a4f-4225-9919-52297129c893-rectangle-2270.png?auto=format&fit=clip',
    name: 'Valeria Bedodo',
    role: 'LEADERS_ROLE2',
    companyLogo:
      'https://crehana-vercel-images-prd.imgix.net/public/b9b741c8-023f-48ca-a5eb-ed214d2ec47c-sura-(1).png?auto=format&fit=clip',
    description: 'LEADERS_STORY2',
  },
  {
    avatar:
      'https://crehana-vercel-images-prd.imgix.net/public/f9a74e96-cb89-4c4a-83f6-a61d0d78ef80-viviana-miglia.jpg?auto=format&fit=clip',
    name: 'Viviana Miglia',
    role: 'LEADERS_ROLE3',
    companyLogo:
      'https://crehana-vercel-images-prd.imgix.net/public/d1a2036b-0b42-4f31-b97e-2c85380c8ca6-logo-bioderma.png?auto=format&fit=clip',
    description: 'LEADERS_STORY3',
  },
];
